import { jsx } from 'react/jsx-runtime';
import { DialogActions } from '@mui/material';
import { forwardRef } from 'react';

const Actions = forwardRef(function DialogActions$1(props, ref) {
    return jsx(DialogActions, Object.assign({ disableSpacing: true }, props, { ref: ref }));
});

export { Actions };
//# sourceMappingURL=DialogActions.js.map
